export default __webpack_public_path__ + "5222b6f4e9395957e37c143bd3eb0051.jpeg";